module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"company.address":"ที่อยู่","company.billing_name":"ชื่อจดทะเบียน","company.billing_address":"ที่อยู่ในการออกบิล","company.juristic_no":"เลขที่นิติบุคคล","company.abbr_name":"ตัวย่อ"}}')
  delete Component.options._Ctor
}
